__turbopack_context__.v({
  "brands": "styles-module-scss-module__uQodNq__brands",
  "brands__title": "styles-module-scss-module__uQodNq__brands__title",
});
